import { axiosInstance } from '../../utils/axios'
import { SELF_TEST_TIMEOUT_MS } from '../../constants/selfTest'
import type { SelfTestReport } from '../../types/selfTest'

interface ApiResponse<T> {
  success: boolean
  data: T
}

const BASE_URL = '/admin/self-test'

export const selfTestApi = {
  /**
   * Runs every read-only endpoint on the API instance that serves this request.
   * The per-request timeout override is required: axiosInstance defaults to 30s,
   * which is shorter than the server's own 45s run deadline.
   */
  run: async (refresh = false): Promise<SelfTestReport> => {
    const res = await axiosInstance.get<ApiResponse<SelfTestReport>>(BASE_URL, {
      params: refresh ? { refresh: true } : undefined,
      timeout: SELF_TEST_TIMEOUT_MS,
    })
    return res.data.data
  },

  /**
   * Re-run a single endpoint after a full run. Uses the API's `only` filter, so
   * it is uncached, uncontended, and cheap — the point is checking whether a
   * failure reproduces without paying for another 68-probe sweep.
   */
  runOne: async (path: string): Promise<SelfTestReport> => {
    const res = await axiosInstance.get<ApiResponse<SelfTestReport>>(BASE_URL, {
      params: { only: path, refresh: true },
      timeout: SELF_TEST_TIMEOUT_MS,
    })
    return res.data.data
  },
}
